import kinesisLogo from 'media/kinesis_logo.png'
import { cn } from 'lib/utils'
import { useSelector } from 'react-redux'
import { useIsTouchDevice } from 'redux/customHooks/useIsTouchDevice'

import OrganizationOverrideBanner from 'components/Admin/OrganizationOverrideBanner'
import SimulationClockBanner from 'components/Admin/SimulationClockBanner'

export default function FullscreenLoading() {

    const isTouchDevice = useIsTouchDevice()
    const dummyItems = isTouchDevice ? 4 : 8

    const overrideOrganizationId = useSelector((state) => state.admin.overrideOrganizationId)
    const simulationClockDayOffset = useSelector((state) => state.simulationClock.simulationClockDayOffset)

    const adminBannerOffsetPx = (
        (overrideOrganizationId !== null ? 44 : 0) +
        (simulationClockDayOffset !== 0 ? 52 : 0)
    )

    return (
        <>
            {overrideOrganizationId !== null && <OrganizationOverrideBanner />}

            {simulationClockDayOffset !== 0 && <SimulationClockBanner />}

            <div 
                className='fixed h-full w-full flex bg-zinc-800 py-1.5 pr-1.5'
                style={adminBannerOffsetPx !== 0 ? { paddingTop: adminBannerOffsetPx } : undefined}
            >

                {/* Dummy sidebar — widths align with DesktopSidebar collapsed rail */}
                <div
                    className={cn(
                        'h-full bg-zinc-800 pt-6 pb-4 flex flex-col items-center',
                        isTouchDevice ? 'w-[80px] px-2 space-y-2' : 'w-[60px] px-4 space-y-3'
                    )}
                >
                    {Array.from({ length: dummyItems }, (_, i) => (
                        <div
                            key={i}
                            className={cn(
                                'w-full bg-white/10 rounded-md animate-pulse shrink-0',
                                isTouchDevice ? 'h-16' : 'h-7'
                            )}
                        />
                    ))}
                </div>

                {/* Dummy content */}
                <div className='h-full flex-grow flex items-center justify-center bg-gray-100 rounded-md'>
                    <div className={cn('space-y-1 pb-20', isTouchDevice ? 'pr-[80px]' : 'pr-[60px]')}>
                        <img src={kinesisLogo} alt='Kinesis Logo' className='mx-auto w-40 h-40 animate-pulse' />
                    </div>
                </div>
            </div>
        </>
    )
}
